import connected from "standard/connected";
import define from "standard/define";
import paint from "standard/paint";
import trait from "standard/trait";
import willPaint from "standard/willPaint";
import style from "./style";

@define("m-avatar")
class Avatar extends HTMLElement {
  #avatar = "";
  #url = `https://hzinyrqqkeqizojcotoj.supabase.co/storage/v1/object/public/avatars/${this.dataset.user}`;

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @willPaint
  async [trait.fetch]() {
    await fetch(
      `https://hzinyrqqkeqizojcotoj.supabase.co/storage/v1/object/public/avatars/${this.dataset.user}`,
    ).then((result) => {
      if (result.status === 400) {
        this.#avatar = "//donna.sistemadulino.com.br/avatar.jpeg";
        return this;
      }

      this.#avatar = this.#url;
    });
  }

  @connected
  @paint
  [trait.template]() {
    return `
      <figure class="${style.figure}">
        <img
          class="${style.figure__avatar}"
          src="${this.#avatar}"
          alt="Avatar"
          loading="eager"
        />
      </figure> 
    `;
  }
}

export default Avatar;
